import React, { useState } from 'react';
import { mockWorkersList } from '../../../_shared/mocks';
import { WorkersList } from '../../components/WorkersList/WorkersList';
import { Select } from '../../../_shared/components/Select/Select';
import { Input } from '../../../_shared/components/Input/Input';
import { KpiFormModal } from '../../../_shared/components/KpiFormModal/KpiFormModal';
import { ReactComponent as SearchIcon } from '../../../_shared/assets/icons/searchIcon.svg';
import { useKpeSelector } from '../../../_shared/store/store';
import styles from './HrApprovalView.module.scss';

const DEPARTMENTS = [
  'Департамент A',
  'Департамент B',
  'Департамент C',
  'Все подразделения'
];
const CATEGORIES = ['Категория1', 'Категория2', 'Категория3', 'Категория4'];
const SORT_OPTIONS = ['Сначала новые', 'Сначала старые'];

export function HrApprovalView() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState<string>('');
  const [selectedCategories, setSelectedCategories] = useState<string>('');
  const [selectedSort, setSelectedSort] = useState<string>('');
  const hasKpi = useKpeSelector((s) => s.kpe.hasKpi);

  return (
    <div className={styles.section}>
      <form className={styles.form}>
        <div className={styles.searchWrapper}>
          <Input
            label="Поиск по ФИО и должности"
            name="search"
            type="text"
            value={searchQuery}
            variant={'grey'}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={styles.searchInput}
          />
          <SearchIcon className={styles.searchIcon} />
        </div>
        <div className={styles.selectors}>
          <div className={styles.filters}>
            <Select
              label="Подразделения"
              options={DEPARTMENTS}
              value={selectedDepartment}
              onChange={(value) => setSelectedDepartment(value ?? '')}
            />
          </div>
          <div className={styles.filters}>
            <Select
              label="Категория"
              options={CATEGORIES}
              value={selectedCategories}
              onChange={(value) => setSelectedCategories(value ?? '')}
            />
          </div>
          <div className={styles.filters}>
            <Select
              label="Сначала новые"
              options={SORT_OPTIONS}
              value={selectedSort}
              onChange={(value) => setSelectedSort(value ?? '')}
            />
          </div>
        </div>
      </form>

      <WorkersList workers={mockWorkersList} />

      <KpiFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={(values) => console.log('submit', values)}
        notification={'Текст возможного уведомления'}
      />
    </div>
  );
}
